import script from "./ProductForm.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductForm.vue?vue&type=script&setup=true&lang=js"

import "./ProductForm.vue?vue&type=style&index=0&id=4780a5a7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4780a5a7"]])

export default __exports__